import React, { Component } from "react"
import axios from "axios"
import BotView from "./BotView"

class Bot extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
      initializing: true,
      changelog: null,
      bots: [],
      currentBot: null,
      changeLog: [],
      alert: null,
      guilds: [],
      botData: null,
      changeRequest: "",
      ajaxLoading: false,
      botError: false,
    }
  }
  updateBotInfo = (event, botid = null) => {
    let currentBot
    let botId = botid ? botid : event.target.value
    //eslint-disable-next-line
    let bot = this.state.bots.filter((bot) => bot.id == botId)[0]
    this.setState({ currentBot: bot, ajaxLoading: true }, () => {
      axios({
        method: "GET",
        url: "/.netlify/functions/updatepage",
        params: {
          id: this.state.currentBot.id,
          userId: this.state.user.id,
        },
      }).then((res) => {
        bot.online = res.data.status
        this.setState({
          changeRequest: "",
          changeLog: res.data.changelog,
          currentBot: bot,
          guilds: res.data.guilds,
          botData: res.data.botData,
          ajaxLoading: false
        })
      })
    })
    console.log(currentBot)
  }
  componentDidMount() {
    const token = localStorage.getItem("discord_token")
    if (!token) this.props.history.push("/")
    else {
      axios({
        method: "GET",
        url: `https://discordapp.com/api/users/@me?scope=identify%20email`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          this.setState({ user: res.data }, () => {
            axios({
              method: "GET",
              url: "/.netlify/functions/getbots",
              params: {
                id: this.state.user.id,
              },
            }).then((res) =>
              this.setState({
                bots: res.data.bots,
                currentBot: res.data.bots[0],
                initializing: false,
                changeLog: res.data.changelog,
                guilds: res.data.guilds,
                botData: res.data.botData
              })
            ).catch(err => {
              this.setState({botError: true}, () => {
                this.setAlert({
                  type: "error",
                  title: "Request Failed!",
                  message: "The request failed because you don't have any bots or something went wrong.",
                  onConfirm: () => {
                    this.clearAlert()
                    this.props.history.push("/")
                  },
                })
              })
            })
          })
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOut()
          } 
        })
    }
  }

  submitChangeMessage = (e, message) => {
    e.preventDefault()
    this.setState({ajaxLoading: true})
    axios({
      url: `${process.env.REACT_APP_API_URL}/change`,
      params: {
        botid: this.state.currentBot.id,
        id: this.state.user.id,
        change: message
      }
    }).then(res => {
      this.setState({ajaxLoading: false})
      if(res.data.status === "failed")
        this.setAlert({
          type: "error",
          title: "Request Failed!",
          message: res.data.message,
          onConfirm: () => {
            this.clearAlert()
            this.setState({
              changeRequest: ""
            })
          },
        })
      else 
        this.setAlert({
          type: "success",
          title: "Request Successful!",
          message: res.data.message,
          onConfirm: () => {
            this.clearAlert()
            this.setState({
              changeRequest: ""
            })
            this.updateBotInfo(null, this.state.currentBot.id)
          },
        })

    }).catch(err => {
      this.setAlert({
        type: "error",
        title: "Error",
        message: `Something went wrong while making the request.`,
        onConfirm: () => this.clearAlert(),
      })
    })
  }

  action = async (signal) => {
    if (this.state.currentBot.online && signal === "start") {
      this.setAlert({
        type: "error",
        title: "Error",
        message: `Sorry, ${this.state.currentBot.name} is already online, so you can't start it`,
        onConfirm: () => this.clearAlert(),
      })
      return
    } else if (
      !this.state.currentBot.online &&
      (signal === "kill" || signal === "stop" || signal === "restart")
    ) {
      this.setAlert({
        type: "error",
        title: "Error",
        message: `Sorry, ${this.state.currentBot.name} is already offline, so you can't ${signal} it`,
        onConfirm: () => this.clearAlert(),
      })
      return
    } else {
      this.setState({ajaxLoading: true})
      try {
        let response = await axios({
          method: "GET",
          url: "/.netlify/functions/botaction",
          params: {
            userId: this.state.user.id,
            botId: this.state.currentBot.id,
            signal,
          },
        })
        this.setState({ajaxLoading: false})
        switch (response.status) {
          case 204:
            this.setAlert({
              type: "success",
              title: "Success",
              message: `${this.state.currentBot.name} was ${
                signal === "stop" ? "stopped" : signal + "ed"
              } successfully`,
              onConfirm: () => this.clearAlert(),
              onCancel: () => this.clearAlert(),
            })
            if (signal === "start" || signal === "restart")
              this.setState((state) => ({
                currentBot: {
                  ...state.currentBot,
                  online: true,
                },
              }))
            else
              this.setState((state) => ({
                currentBot: {
                  ...state.currentBot,
                  online: false,
                },
              }))
            break
          default:
            this.setAlert({
              type: "warning",
              title: "Error",
              message: "Something went wrong",
            })
        }
      } catch (err) {
        this.setState({ajaxLoading: false})
        if (
          err.response.status === 500 &&
          (signal === "stop" || signal === "restart")
        )
          this.setAlert({
            type: "success",
            title: "Success",
            message: `${this.state.currentBot.name} was ${
              signal === "stop" ? "stopped" : signal + "ed"
            } successfully`,
            onConfirm: () => this.clearAlert(),
            onCancel: () => this.clearAlert(),
          })
        if (signal === "stop")
          this.setState((state) => ({
            currentBot: {
              ...state.currentBot,
              online: false,
            },
          }))
        if (signal === "restart")
          this.setState((state) => ({
            currentBot: {
              ...state.currentBot,
              online: true,
            },
          }))
      }
    }
  }

  onInputChange = elem => {
    const value =
      elem.target.type === "checkbox" ? elem.target.checked : elem.target.value
    const key = elem.target.name
    this.setState(state => ({
        [key]: value,
    }))
  }

  setAlert = (alert) => this.setState({ alert: { ...alert } })

  clearAlert = () => this.setState({ alert: null })

  logOut = () => {
    localStorage.removeItem("discord_token")
    this.props.history.push("/")
  }
  render() {
    return (
      <BotView
        updateBotInfo={this.updateBotInfo}
        submitChangeMessage={this.submitChangeMessage}        
        action={this.action}
        onInputChange={this.onInputChange}
        logOut={this.logOut}
        {...this.state}
      />
    )
  }
}

export default Bot



// WEBPACK FOOTER //
// ./src/routes/bot/Bot.js